import { render, staticRenderFns } from "./YinHuaShuiUploaderComponent.vue?vue&type=template&id=4749fa36&scoped=true"
import script from "./YinHuaShuiUploaderComponent.vue?vue&type=script&lang=js"
export * from "./YinHuaShuiUploaderComponent.vue?vue&type=script&lang=js"
import style0 from "./YinHuaShuiUploaderComponent.vue?vue&type=style&index=0&id=4749fa36&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4749fa36",
  null
  
)

export default component.exports